function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SubMixin from './mixins/sub';
import HeadTable from './headTable.js';
import BodyTable from './bodyTable';
import VirtualBodyTable from './virtualBodyTable';
var __vue_script__ = {
  name: 'MainTable',
  components: {
    HeadTable: HeadTable,
    BodyTable: BodyTable,
    VirtualBodyTable: VirtualBodyTable
  },
  mixins: [SubMixin],
  computed: {
    scrollable: function scrollable() {
      var fixed = this.fixed,
          scroll = this.scroll,
          isAnyColumnsFixed = this.isAnyColumnsFixed,
          isFixedHeader = this.isFixedHeader;
      return !fixed && (isAnyColumnsFixed || scroll.x || isFixedHeader);
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          scrollable = this.scrollable;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-main-table"), true), _defineProperty(_ref, "".concat(prefixCls, "-scroll"), scrollable), _ref;
    },
    headTableRef: function headTableRef() {
      return this.elementRefs.headTableRef;
    },
    bodyTableRef: function bodyTableRef() {
      return this.elementRefs.bodyTableRef;
    },
    fixedAndBodyTableRefs: function fixedAndBodyTableRefs() {
      var elementRefs = this.elementRefs;
      return [elementRefs.bodyTableRef, elementRefs.leftBodyTableRef, elementRefs.rightBodyTableRef];
    }
  },
  methods: {
    updatePrevScrollLeft: function updatePrevScrollLeft(scrollLeft) {
      this.rootVM.updatePrevScrollLeft(scrollLeft);
    },
    updatePrevScrollTop: function updatePrevScrollTop(scrollTop) {
      this.rootVM.updatePrevScrollTop(scrollTop);
    },
    onScrollX: function onScrollX(e) {
      var scroll = this.scroll,
          prevScrollLeft = this.prevScrollLeft,
          headTableRef = this.headTableRef,
          bodyTableRef = this.bodyTableRef;
      var target = e.target;
      var scrollLeft = target.scrollLeft;

      if (scrollLeft !== prevScrollLeft && scroll.x) {
        // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/234
        if (headTableRef && target === bodyTableRef) {
          headTableRef.scrollLeft = scrollLeft;
        } else if (bodyTableRef && target === headTableRef) {
          bodyTableRef.scrollLeft = scrollLeft;
        }

        this.updatePrevScrollLeft(scrollLeft);
        this.$emit('scroll-x', scrollLeft);
      }
    },
    onScrollY: function onScrollY(e) {
      var fixedAndBodyTableRefs = this.fixedAndBodyTableRefs,
          prevScrollTop = this.prevScrollTop,
          scroll = this.scroll,
          virtualScrollMode = this.virtualScrollMode;
      var target = e.target;
      var scrollTop = target.scrollTop;

      if (scrollTop !== prevScrollTop && (scroll.y || virtualScrollMode)) {
        fixedAndBodyTableRefs.forEach(function (ref) {
          var nRef = ref;

          if (nRef && nRef !== target) {
            nRef.scrollTop = scrollTop;
          }
        });
        this.updatePrevScrollTop(scrollTop);
      }
    },
    onBodyScroll: function onBodyScroll(e) {
      if (e.currentTarget === e.target) {
        if (!this.fixed) {
          this.onScrollX(e);
        }

        this.onScrollY(e);
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes
  }, [_vm.isFixedHeader && !_vm.hideHeader ? _c('head-table', {
    attrs: {
      "fixed": _vm.fixed
    },
    on: {
      "head-scroll": _vm.onScrollX
    }
  }) : _vm._e(), !_vm.virtualScrollMode ? _c('body-table', {
    attrs: {
      "has-head": !_vm.isFixedHeader && !_vm.hideHeader,
      "fixed": _vm.fixed
    },
    on: {
      "body-scroll": _vm.onBodyScroll
    }
  }) : _c('virtual-body-table', {
    attrs: {
      "fixed": _vm.fixed
    },
    on: {
      "body-scroll": _vm.onBodyScroll
    }
  }), !_vm.fixed ? [_vm.records.length === 0 ? _c('div', {
    class: _vm.prefixCls + "-placeholder"
  }, [_vm._t("empty")], 2) : _vm._e(), _vm.$scopedSlots.footer || _vm.$slots.footer ? _c('div', {
    class: _vm.prefixCls + "-footer"
  }, [_vm._t("footer", null, {
    "records": _vm.records
  })], 2) : _vm._e()] : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "mainTable.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);